import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, CircularProgress, Container, Grid, Snackbar} from "@mui/material";
import styles from "../../assets/css/user.module.scss";
import {TextField} from "../../../../components/subComponents/TextField";
import LoadingButton from "../../../../components/subComponents/LoadingButton";
import {Editor} from "@tinymce/tinymce-react";
import {useNavigate, useParams} from "react-router-dom";
import {NewsApi} from "../../../../utils/NewsApi";
import {styled} from '@mui/material/styles';
import configs from '../../../../utils/config.json';
import {CategoryApi} from "../../../../utils/CategoryApi";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Input = styled('input')({
    display: 'none',
});
const Category = (props) => {
    const navigate = useNavigate();
    const ref = useRef();
    const params = useParams();

    const [sending, setSending] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const editorRef = useRef(null);
    const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
    const [message, setMessage] = useState('');
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const sendDataToServer = async () => {
        setSending(true);

        if (params.id) {
            const update = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    name: title,

                }));
                await CategoryApi.update(fd,params.id,
                    async (result) => {
                        handleClickSnackBar1("دسته بروزرسانی شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/category");
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await update();
        } else {
            const insert = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    name: title
                }));
                await CategoryApi.insert(fd,
                    async (result) => {
                        handleClickSnackBar1("دسته افزوده شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/category");
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await insert();
        }

    }
    useEffect(() => {
        if (params.id) {
            (async () => {
                await CategoryApi.get(params.id,1, ({data}) => {
                    setTitle(data.name);

                }, (error) => {
                });
            })();
        }
    }, []);
    return <div>
        <Container maxWidth={"md"}>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان" variant="outlined"
                                           value={title}
                                           onChange={e => {
                                               setTitle(e.target.value)
                                           }}
                                           fullWidth
                                />
                            </div>
                        </Grid>




                    </Grid>
                    <Button color="error" onClick={() => {
                        navigate(-1);
                    }}>
                        انصراف
                    </Button>

                    <LoadingButton
                        loading={sending}
                        loadingPosition="end"
                        variant={'text'}
                        color="primary"
                        component="button"
                        onClick={() => {
                            sendDataToServer();
                        }}
                    >
                        ثبت
                    </LoadingButton>

                </Grid>
            </Grid>

        </Container>

        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert onClose={handleCloseSnackBar1} severity="info"
                   action={null

                   }
                   className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>;
}
export default Category;